const ShoppingCart = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#000",
  ...props
}) => (
  <svg
    viewBox="0 0 1136 1024"
    version="1.1"
    p-id="18378"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M539.968785 1024a68.494983 68.494983 0 1 1 68.494983-68.494983 68.494983 68.494983 0 0 1-68.494983 68.494983zM963.496098 1024a68.494983 68.494983 0 1 1 68.494983-68.494983 68.494983 68.494983 0 0 1-68.494983 68.494983zM421.244147 873.881828a43.380156 43.380156 0 0 1-37.101449-21.119286 118.724638 118.724638 0 0 1-11.415831-123.29097 182.653289 182.653289 0 0 1 128.998886-75.915273L277.404682 86.189521H43.380156A43.380156 43.380156 0 0 1 43.380156 0h263.134894a42.809365 42.809365 0 0 1 39.955407 27.397993l77.627648 196.352286h656.410256a43.380156 43.380156 0 0 1 43.380156 43.380156v308.798216a43.380156 43.380156 0 0 1-33.6767 42.238573l-140.985507 30.822743h-6.849498L570.791527 731.754738h-7.42029c-46.804905 0-103.884058 17.694537-114.158305 38.243032a22.831661 22.831661 0 0 0 0 15.982163c81.623188 0 331.629877-5.137124 616.454849-5.137124a43.380156 43.380156 0 1 1 0 86.189521c-331.059086 0-611.888517 4.566332-642.711259 5.137124z m167.812709-234.024526l73.632107-15.982163-41.667781-120.437012-84.477146 5.137124z m158.680045-34.818283l132.423634-29.110368-31.964325-86.760312-137.560758 8.561873z m217.471572-47.946488l73.061315-15.982163V477.181717l-99.888517 6.278707zM503.438127 424.098105l87.331104-5.707915-37.672241-108.450391H456.633222z m176.945374-11.415831l136.419175-8.561873-34.818284-94.180602h-137.560758z m228.31661-14.269788l131.282052-7.991081V309.939799h-166.100335z"
      fill={color}
      p-id="18379"
    ></path>
  </svg>
);

export default ShoppingCart;
